module.exports = __webpack_public_path__ + "img/loading.1bae3963.gif";